import { Step, StepConnector, stepConnectorClasses, StepLabel, Stepper, styled, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';

import { getStepperConfig, STEP_LABELS } from '../../../config/stepper-stage-map';
import { CoastStepIcon, type CoastStepState } from '../coast-step-icon';
import { useStepperOverride } from './useStepperOverride';

const stepLabelColors: Record<CoastStepState, string> = {
  default: 'text.disabled',
  notReached: 'text.disabled',
  pending: 'text.secondary',
  active: 'primary.main',
  done: 'text.primary',
  success: 'success.main',
  rejected: 'error.main',
};

const StepperConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.active}, &.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.main,
    },
  },
}));

const ProgressStepper = () => {
  const { pathname } = useLocation();
  const states = getStepperConfig(pathname, useStepperOverride());

  if (!states) {
    return null;
  }

  return (
    <Stepper
      alternativeLabel
      nonLinear
      connector={<StepperConnector />}
      sx={{ my: 5, maxWidth: (theme) => theme.spacing(75), mx: 'auto' }}
    >
      {STEP_LABELS.map((label, index) => (
        <Step key={label} active={states[index] === 'active'} completed={states[index] !== 'notReached'}>
          <StepLabel icon={<CoastStepIcon state={states[index]} stepNumber={index + 1} />}>
            <Typography component="span" variant="body2" sx={{ color: stepLabelColors[states[index]] }}>
              {label}
            </Typography>
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export { ProgressStepper };
